/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UrlDataService } from "src/app/services/url-data/url-data.service";
@Component({
  selector: "app-check-url",
  templateUrl: "./check-url.component.html",
  styleUrls: ["./check-url.component.scss"],
})
export class CheckUrlComponent implements OnInit {
  code = {};
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private urlData: UrlDataService
  ) {}

  ngOnInit() {
    switch (this.activatedRoute.snapshot.url[0].path) {
      case "qr": {
        this.activatedRoute.queryParamMap.subscribe((params) => {
          if (
            params &&
            (params.get("s") || params.get("b") || params.get("i"))
          ) {
            if (params.get("s")) {
              this.code["sequence"] = params.get("s");
              console.log(params.get("s"));
            }
            if (params.get("b")) {
              this.code["batchNumber"] = params.get("b");
              console.log(params.get("b"));
            }
            if (params.get("i")) {
              this.code["itemCode"] = params.get("i");
              console.log(this.code);
            }
            console.log(this.code);
            this.urlData.productData = this.code;
            this.router.navigateByUrl("product");
          }
        });
        break;
      }
      case "offer-qr": {
        this.activatedRoute.queryParamMap.subscribe((params) => {
          if (params) {
            if (params.get("offerNumber")) {
              this.code["offerNumber"] = params.get("offerNumber");
            }

            this.urlData.offerData = this.code;
            this.router.navigateByUrl("offer/offer-details");
          }
        });
        break;
      }
    }
  }
}
